import * as React from 'react'
import * as rt from '../../config/routeType'
import { Box, styled, Stack } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { changePopup, setMarker } from '../../redux/slices/Map/map'
import { Link } from 'react-router-dom'
import { Typography as MIUTypography } from '@mui/material'
import NaturePeopleIcon from '@mui/icons-material/NaturePeople'
import AppRegistrationIcon from '@mui/icons-material/AppRegistration'
import UploadFileIcon from '@mui/icons-material/UploadFile'

const styleIcons = { fontSize: '3em', color: '#1f874c' }
const styleStack = {
  direction: 'column',
  alignItems: 'center',
  spacing: 1,
  py: 2,
  px: 3,
  justifyContent: 'start',
  height: '100%',
}

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '0.9em',
  fontWeight: props.istitle ? 600 : 450,
  lineHeight: props.istitle ? '18px' : '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))

const Management = ({ roleUser, children }) => {
  const dispatch = useDispatch()
  const popupOpen = useSelector(state => state.mapState.popupOpen)

  React.useEffect(() => {
    if (popupOpen) {
      dispatch(changePopup(false))
      dispatch(setMarker({ openMarker: false, draggable: false, lnglat: [] }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        scrollBehavior: 'smooth',
      }}>
      <Stack {...styleStack}>
        <Box>
          <NaturePeopleIcon sx={styleIcons} />
          <AppRegistrationIcon sx={styleIcons} />
          <UploadFileIcon sx={styleIcons} />
        </Box>
        <Box pb={6}>
          <Typography istitle="true">
            Proyecto 17-DI-FARNR-2021 <br />
            “Dinámica de crecimiento y servicios ecosistémicos del arbolado urbano de la
            ciudad de Loja”
          </Typography>
        </Box>
        <Box pb={1}>
          <Typography istitle="true">
            ADMINISTRACIÓN DE LOS REGISTROS DE ÁRBOLES
          </Typography>
        </Box>
        <Box pb={2}>
          <Typography>
            Seleccione un punto de interés en el mapa para mostrar las acciones
            disponibles.
          </Typography>
        </Box>
        <Box pb={3}>
          <Typography istitle="true">Editar árbol</Typography>
          <Typography>
            Escoja la acción "Editar", seguidamente de "Habilitar edición" y agregue,
            elimine o corrija los campos deseados. *Algunos campos serán obligatorios.
          </Typography>
        </Box>
        <Box pb={3}>
          <Typography istitle="true">Desplazar ubicación</Typography>
          <Typography>
            Escoja la acción "Desplazar", seguidamente mueva el marcador a una nueva
            ubicación, finalice la acción haciendo clic en el botón "Fijar". Los nuevos
            cambios se almacenarán al presionar el botón "Guardar" en el formulario.
          </Typography>
        </Box>
        <Box pb={3}>
          <Typography istitle="true">Eliminar árbol</Typography>
          <Typography>
            Escoja la acción "Eliminar", confirme la acción "Eliminar".
          </Typography>
        </Box>
        {roleUser.includes('administrador') && (
          <Box>
            <Box pb={1}>
              <Typography istitle="true">ADMINISTRACIÓN DE REGISTROS GLOBALES</Typography>
            </Box>
            <Typography istitle="true">Administración</Typography>
            <Typography>
              Cree, actualice o elimine registros comunes,{' '}
              <Link to={`../${rt.TABLE_RECORDS}`}>click aquí</Link>.
            </Typography>
          </Box>
        )}
        {children}
      </Stack>
    </Box>
  )
}

export default Management
